import MicroModal from "micromodal";
import { useEffect, useRef, useState } from 'react'

export const ConfirmationModal = () => {

  const modalID = 'delete-earned-accred-modal'
  const [ earnedAccredID, setEarnedAccredID ] = useState(null)
  const [ fetching, setFetching ] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    MicroModal.init()

    // Observe selected earned accred
    const observer = new MutationObserver(( mutationList) => {
      for ( const mutation of mutationList ) {
        if ( mutation.attributeName === 'value' ) {
          setEarnedAccredID(ref.current.value)

          if ( ref.current.value ) MicroModal.show( modalID, { onClose: () => setEarnedAccredID(null) })
        }
      }
    })
    observer.observe(ref.current, { attributes: true })

  }, [])

  const deleteEarnedAccred = () => {
    setFetching(true)

    window.Tangible.ajax( 'tgbl_cred_delete_earned_accreditation', { id: earnedAccredID })
      .then(res => {
        setFetching(false)
        window.location.reload()
      })
      .catch( err => {
        setFetching(false)
        console.log(err)
      })
  }

  return (
    <>
      <input ref={ref} id={`${modalID}-value`} type="hidden"/>
      <div id={modalID} className="tgbl-modal tgbl-modal--confirmation-box tf-context-default" aria-hidden={(earnedAccredID === null).toString()} data-tgbl-micromodal-animation="slide">
        <div className="tgbl-modal__overlay" tabIndex="-1" data-micromodal-close={modalID}>
          <div className="tgbl-modal__container" role="dialog" aria-modal="true" aria-labelledby={`${modalID}-title`}>
            <header className="tgbl-modal__header">
              <div className="tgbl-group-report__data__item__header">
                <div className="tgbl-group-report__data__item__header__details">
                  <div className="tgbl-modal__title" id={`${modalID}-title`}>Delete Earning Accreditation Confirmation</div>
                </div>
              </div>
              <button className="tgbl-modal__close tf-button-text-action " aria-label="Close modal" data-micromodal-close={modalID}>
                <svg className="tgbl-icon tgbl-icon--exit" fill="none" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                  <path fillRule="evenodd" clipRule="evenodd" d="m12 12.9-6.5 6.6-1-1 6.5-6.7-6.1-6.3 1-1 6.1 6.2 6-6.2 1.1 1-6 6.3 6.4 6.7-1 1L12 13Z" fill="currentColor"/>
                </svg>
              </button>
            </header>
            <main className="tgbl-modal__content" id={`${modalID}-content`}>
              <h4>Are you sure you want to delete this earned accreditation? </h4>
              <p>We generally don't recommend deleting these, as in most cases earned accreditations are treated as an immutable log of user activity.</p>
              <span className="text-warning">This action cannot be reversed!</span>
              <div className="action-buttons">
                <button
                  className="tf-button-danger"
                  onClick={deleteEarnedAccred}
                  disabled={fetching}
                >{fetching ? 'Deleting...' : 'Delete'}</button>
                <button className="tf-button-text-primary" data-micromodal-close={modalID} disabled={fetching}>Cancel</button>
              </div>
            </main>
          </div>
        </div>
      </div>
    </>
  )
}
